module.exports = __webpack_public_path__ + "img/ic_add.76174744.png";